#import "../fragments/ai-stat-fragment.graphql"

query GetAiFeature($type: AiFeatureType!, $period: AiFeaturePeriod!) {
    aiFeature(type: $type, period: $period) {
        type
        requiresUpgrade
        minimumPlanName
        ... on AiFeatureWithStats {
            stats {
                ...AiStatFragment
            }
            loggedInUserHasUsed
        }
    }
}
